<template>
  <div id="app">
    <!-- 推荐给朋友弹窗 -->
    <div
      class="guide-mask"
      @touchmove.stop.prevent="touchstartReturn"
      v-show="this.$store.state.shareFlag"
    >
      <img src="./assets/images/wxshare-bg.png" />
      <p>在微信浏览器点击右上角分享给微信好友</p>
      <div class="btn" @click="openCloseShar">知道了</div>
    </div>
    <!-- 加载中动画 -->
    <div
      class="my-loading"
      style="display: block"
      @touchstart.stop.prevent="touchstartReturn"
      v-show="this.$store.state.loadingFlag"
    >
      <div id="preview">
        <div class="spinner">
          <div style="position: absolute; top: -2px; opacity: 0.1">
            <div
              style="
                position: absolute;
                width: 11px;
                height: 4px;
                background: rgb(255, 255, 255);
                box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 1px;
                transform-origin: left center 0px;
                transform: rotate(0deg) translate(10px, 0px);
                border-radius: 2px;
              "
            ></div>
          </div>
          <div style="position: absolute; top: -2px; opacity: 0.2">
            <div
              style="
                position: absolute;
                width: 11px;
                height: 4px;
                background: rgb(255, 255, 255);
                box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 1px;
                transform-origin: left center 0px;
                transform: rotate(27deg) translate(10px, 0px);
                border-radius: 2px;
              "
            ></div>
          </div>
          <div style="position: absolute; top: -2px; opacity: 0.3">
            <div
              style="
                position: absolute;
                width: 11px;
                height: 4px;
                background: rgb(255, 255, 255);
                box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 1px;
                transform-origin: left center 0px;
                transform: rotate(55deg) translate(10px, 0px);
                border-radius: 2px;
              "
            ></div>
          </div>
          <div style="position: absolute; top: -2px; opacity: 0.4">
            <div
              style="
                position: absolute;
                width: 11px;
                height: 4px;
                background: rgb(255, 255, 255);
                box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 1px;
                transform-origin: left center 0px;
                transform: rotate(83deg) translate(10px, 0px);
                border-radius: 2px;
              "
            ></div>
          </div>
          <div style="position: absolute; top: -2px; opacity: 0.5">
            <div
              style="
                position: absolute;
                width: 11px;
                height: 4px;
                background: rgb(255, 255, 255);
                box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 1px;
                transform-origin: left center 0px;
                transform: rotate(110deg) translate(10px, 0px);
                border-radius: 2px;
              "
            ></div>
          </div>
          <div style="position: absolute; top: -2px; opacity: 0.6">
            <div
              style="
                position: absolute;
                width: 11px;
                height: 4px;
                background: rgb(255, 255, 255);
                box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 1px;
                transform-origin: left center 0px;
                transform: rotate(138deg) translate(10px, 0px);
                border-radius: 2px;
              "
            ></div>
          </div>
          <div style="position: absolute; top: -2px; opacity: 0.7">
            <div
              style="
                position: absolute;
                width: 11px;
                height: 4px;
                background: rgb(255, 255, 255);
                box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 1px;
                transform-origin: left center 0px;
                transform: rotate(166deg) translate(10px, 0px);
                border-radius: 2px;
              "
            ></div>
          </div>
          <div style="position: absolute; top: -2px; opacity: 0.8">
            <div
              style="
                position: absolute;
                width: 11px;
                height: 4px;
                background: rgb(255, 255, 255);
                box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 1px;
                transform-origin: left center 0px;
                transform: rotate(193deg) translate(10px, 0px);
                border-radius: 2px;
              "
            ></div>
          </div>
          <div style="position: absolute; top: -2px; opacity: 0.9">
            <div
              style="
                position: absolute;
                width: 11px;
                height: 4px;
                background: rgb(255, 255, 255);
                box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 1px;
                transform-origin: left center 0px;
                transform: rotate(221deg) translate(10px, 0px);
                border-radius: 2px;
              "
            ></div>
          </div>
          <div style="position: absolute; top: -2px; opacity: 1">
            <div
              style="
                position: absolute;
                width: 11px;
                height: 4px;
                background: rgb(255, 255, 255);
                box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 1px;
                transform-origin: left center 0px;
                transform: rotate(249deg) translate(10px, 0px);
                border-radius: 2px;
              "
            ></div>
          </div>
          <div style="position: absolute; top: -2px; opacity: 0.9">
            <div
              style="
                position: absolute;
                width: 11px;
                height: 4px;
                background: rgb(255, 255, 255);
                box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 1px;
                transform-origin: left center 0px;
                transform: rotate(276deg) translate(10px, 0px);
                border-radius: 2px;
              "
            ></div>
          </div>
          <div style="position: absolute; top: -2px; opacity: 0.8">
            <div
              style="
                position: absolute;
                width: 11px;
                height: 4px;
                background: rgb(255, 255, 255);
                box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 1px;
                transform-origin: left center 0px;
                transform: rotate(304deg) translate(10px, 0px);
                border-radius: 2px;
              "
            ></div>
          </div>
          <div style="position: absolute; top: -2px; opacity: 0.7">
            <div
              style="
                position: absolute;
                width: 11px;
                height: 4px;
                background: rgb(255, 255, 255);
                box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 1px;
                transform-origin: left center 0px;
                transform: rotate(332deg) translate(10px, 0px);
                border-radius: 2px;
              "
            ></div>
          </div>
        </div>
        <div class="my-loading-txt">{{ this.$store.state.loadingTxt }}</div>
      </div>
    </div>
    <!-- 公共的toots-success提示 -->
    <div class="toots-success" v-show="this.$store.state.tootsSuccessFlag">
      <img src="./assets/images/updataFile/success-icon.png" />
      <p>{{ this.$store.state.tootsSuccessTxt }}</p>
    </div>
    <!-- 公共的toots提示 -->
    <div class="toots" v-show="this.$store.state.tootsFlag">
      {{ this.$store.state.tootsTxt }}
    </div>
    <!-- 已选项 -->
    <div
      class="shoppingCart-icon"
      @click="goShoppingCart"
      v-if="this.$route.name == 'Index' || this.$route.name == 'ProductDetails'"
    >
      <img
        src="./assets/images/updataFile/ShoppingCart-icon.png"
        class="icon"
      />
      <div
        class="shoppingCartNumberDot"
        v-if="this.$store.state.shoppingCartNumber > 0"
      >
        <span>{{ this.$store.state.shoppingCartNumber }}</span>
      </div>
    </div>
    <!-- 每一个页面的title修改 -->
    <div
      v-wechat-title="
        $route.meta.title ? $route.meta.title : this.$store.state.title
      "
    ></div>
    <div
      class="content"
      :style="{
        width: this.$store.state.PCFlag ? '11.04rem' : '',
        margin: '0 auto',
      }"
    >
      <transition :name="this.$store.state.transitionName">
        <router-view
          class="child-view"
          :style="{
            width: this.$store.state.PCFlag ? '11.04rem' : '',
            margin: '0 auto',
          }"
        ></router-view>
      </transition>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  async created() {
    /* 判断当前页是否需要登录 */
    if (
      localStorage.getItem("tokenTime") &&
      (localStorage.getItem("tokenTime") - new Date().getTime()) / 1000 > 50
    )
      this.overdueToken(
        localStorage.getItem("tokenTime") - new Date().getTime()
      );
    else this.getToken();

    /* 判断当前页是否需要登录 */
    if (this.$route.meta.needLogin) {
      /* 判断是否是微信浏览器，如果是微信浏览器判断是否登录并且是否有openId，没有就重新登录 */
      if (!localStorage.getItem("userInfo")) this.$goLogin();
      else {
        let userInfo = JSON.parse(localStorage.getItem("userInfo"));
        this.isUser(userInfo.id, true);
        // if (userInfo) {
        //   if (!userInfo.mobile) this.$goLogin();
        //   else if (this.$isWeixin()) if (!userInfo.openId) this.$goLogin();
        // } else this.isUser(userInfo.id, true);
      }
    }
    this.browserRedirect();
  },
  watch: {
    $route(to, from) {
      window.scrollTo(0, 0);
      this.$store.state.loadingFlag = false;
      /* 判断当前页是否需要登录 */
      if (this.$route.meta.needLogin) {
        /* 判断是否是微信浏览器，如果是微信浏览器判断是否登录并且是否有openId，没有就重新登录 */
        if (!localStorage.getItem("userInfo")) this.$goLogin();
        else {
          let userInfo = JSON.parse(localStorage.getItem("userInfo"));
          this.isUser(userInfo.id, true);
          // if (userInfo) {
          //   if (!userInfo.mobile) this.$goLogin();
          //   else if (this.$isWeixin()) if (!userInfo.openId) this.$goLogin();
          // } else this.isUser(userInfo.id, true);
        }
      }
      /* 给路由切换的时候加上动画 并在主页面去除动画 */
      const routerArr = ["MyTesting", "Index", "Personal"];
      if (routerArr.includes(to.name) && routerArr.includes(from.name))
        this.$store.state.transitionName = "";
      else {
        if (to.name == "Login" || from.name == "Login") {
          if (from.name == "userProtocol")
            this.$store.state.transitionName = "slide-right";
          else this.$store.state.transitionName = "slide-left";
        } else {
          if (to.meta.index && from.meta.index) {
            if (to.meta.index > from.meta.index)
              this.$store.state.transitionName = "slide-left";
            else this.$store.state.transitionName = "slide-right";
          } else this.$store.state.transitionName = "slide-left";
        }
      }
      setTimeout(() => {
        this.getDiscount();
      }, 1000);
    },
  },
  methods: {
    getToken() {
      localStorage.removeItem("tokenTime");
      var xhr = new XMLHttpRequest();
      xhr.open("post", "https://api.ibnsina360.com/employee/login", false);
      xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
      xhr.onload = (res) => {
        let myres = JSON.parse(res.currentTarget.response);
        if (myres.code == 200) {
          localStorage.setItem("tokenTime", myres.data.expiration);
          localStorage.setItem("token", myres.data.toKen);
          this.overdueToken(myres.data.expiration);
        }
      };
      xhr.send(
        JSON.stringify({
          username: "token",
          password: "gettoken",
        })
      );
    },
    /*判断是否是电脑访问，如果是电脑访问跳转到PC端 */
    browserRedirect() {
      var sUserAgent = navigator.userAgent.toLowerCase();
      var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
      var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
      var bIsMidp = sUserAgent.match(/midp/i) == "midp";
      var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
      var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
      var bIsAndroid = sUserAgent.match(/android/i) == "android";
      var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
      var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
      if (
        bIsIpad ||
        bIsIphoneOs ||
        bIsMidp ||
        bIsUc7 ||
        bIsUc ||
        bIsAndroid ||
        bIsCE ||
        bIsWM
      ) {
        //手机端访问
        localStorage.setItem("PCFlag", false);
        this.$store.state.PCFlag = false;
      } else {
        //电脑端访问
        if (document.documentElement.clientWidth > 414) {
          localStorage.setItem("PCFlag", true);
          this.$store.state.PCFlag = true;
        } else {
          localStorage.setItem("PCFlag", false);
          this.$store.state.PCFlag = false;
        }
      }
    },
    /* 跳转到已选项 */
    goShoppingCart() {
      this.$router.push({
        name: "ShoppingCart",
        query: {
          openId: "wxOpenId",
          doctorId: localStorage.getItem("doctorId"),
        },
      });
    },
    /**
     * 查询数据库是否有该用户，没有就跳转去登录
     */
    isUser(id, goLoginFlag) {
      return new Promise((success, error) => {
        this.$http.get(`/userInfo/baseControllerGetById/${id}`).then((res) => {
          if (res.data.code == 200) {
            if (!res.data.data) {
              if (goLoginFlag) this.$goLogin();
            } else {
              let userInfo = res.data.data;
              if (!userInfo.mobile || !userInfo.openId) this.$goLogin();
              // if (!userInfo.mobile) this.$goLogin();
              else localStorage.setItem("userInfo", JSON.stringify(userInfo));
            }
          }
          success();
        });
      }).catch((err) => {
        success();
      });
    },
    /**
     * 关闭打开分享
     */
    openCloseShar() {
      this.$store.state.shareFlag = !this.$store.state.shareFlag;
    },
    /**
     *出现加载中的时候不让滚动
     */
    touchstartReturn() {
      return;
    },
    /**
     * token过期定时器
     */
    overdueToken(num) {
      num = Math.floor(num / 1000);
      let id = setInterval(() => {
        num = num - 10;
        if (num <= 0) {
          clearInterval(id);
          this.getToken();
        }
      }, 10000);
    },
  },
};
</script>

<style lang="less">
.overflow {
  overflow: hidden;
}
.child-view {
  position: absolute;
  width: 100%;
  transition: all 0.4s;
  min-height: 100%;
}
.slide-left-enter,
.slide-right-leave-active {
  opacity: 0;
  -webkit-transform: translate(100%, 0);
  transform: translate(100%, 0);
}
.slide-left-leave-active,
.slide-right-enter {
  opacity: 0;
  -webkit-transform: translate(-100%, 0);
  transform: translate(-100%, 0);
}
/* 不是微信浏览器的title */
.noWxTitle {
  height: 84px;
  line-height: 84px;
  background-color: rgba(238, 238, 238, 0.8);
  display: flex;
  justify-content: space-between;
  padding-left: 30px;
  padding-right: 30px;
  .left {
    width: 19px;
    height: 34px;
    margin-top: 25px;
  }
  .center {
    font-size: 34px;
    font-weight: 700;
    flex: 1;
    text-align: center;
  }
}
/* 回到顶部 */
.gotop {
  width: 80px;
  height: 80px;
  position: fixed;
  bottom: 140px;
  right: 30px;
  z-index: 1;
}
@keyframes myfirst {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.my-loading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0);
  z-index: 999;
  .my-loading-txt {
    position: absolute;
    bottom: 30px;
    font-size: 26px;
    left: 50%;
    transform: translateX(-50%);
  }
  #preview {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: rgba(0, 0, 0, 0.6);
    color: #fff;
    float: left;
    width: 220px;
    height: 220px;
    -webkit-border-radius: 10px;
    -moz-border-radius: 10px;
    border-radius: 10px;
    .spinner {
      position: absolute;
      top: 40%;
      left: 50%;
      animation: myfirst 2s linear 0s infinite normal;
      width: 0px;
      height: 0px;
      > div {
        transform: scale(0.8);
      }
    }
  }
}
/* 已选项icon */
.shoppingCart-icon {
  position: fixed;
  // right: 30px;
  right: 50%;
  transform: translateX(300%);
  bottom: 210px;
  width: 108px;
  height: 108px;
  background-color: #1968a8;
  box-shadow: 0 0 6px 1px #1968a8;
  border-radius: 100%;
  z-index: 2;
  .icon {
    width: 90px;
    height: 90px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .shoppingCartNumberDot {
    font-size: 28px;
    width: 48px;
    height: 48px;
    border: 1px solid #fff;
    background-color: #ff4a44;
    border-radius: 100%;
    position: absolute;
    top: -10px;
    right: -10px;
    color: #fff;
    text-align: center;
    span {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
}
/* 引导页模态框 */
.guide-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 11;
  img {
    width: 201px;
    height: 403px;
    position: absolute;
    top: 20px;
    right: 80px;
  }
  p {
    position: absolute;
    top: 453px;
    right: 70px;
    font-size: 34px;
    color: #fff;
  }
  .btn {
    position: absolute;
    top: 653px;
    left: 50%;
    transform: translateX(-50%);
    width: 360px;
    height: 90px;
    line-height: 86px;
    font-size: 34px;
    color: #fff;
    border-radius: 6px;
    text-align: center;
    border: 2px solid #fff;
    background-color: rgba(173, 173, 173, 0.5);
  }
}
// 退出登录和取消订单的通用弹窗样式

.mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 5;
  .mask-content {
    width: 546px;
    padding-bottom: 40px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: #fff;
    border-radius: 10px;
    text-align: center;
    .shut {
      position: absolute;
      top: 30px;
      right: 30px;
      width: 26px;
      height: 26px;
    }
    .title {
      padding-top: 43px;
      font-size: 32px;
      font-weight: 700;
    }
    .direction {
      font-size: 28px;
      color: #999999;
      line-height: 134px;
    }
    .btn {
      display: flex;
      justify-content: space-between;
      padding-left: 30px;
      padding-right: 30px;
      > div {
        width: 225px;
        height: 88px;
        border: 1px solid #1968a8;
        line-height: 87px;
        border-radius: 10px;
        font-size: 28px;
      }
      .yes {
        color: #1968a8;
      }
      .no {
        background-color: #1968a8;
        border: none;
        color: #fff;
      }
    }
  }
}
/* 公用提示 */
.toots-success {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 24px;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.5);
  height: 219px;
  width: 236px;
  border-radius: 6px;
  z-index: 999;
  img {
    width: 77px;
    height: 56px;
    display: block;
    margin: 0 auto;
    margin-top: 50px;
  }
  p {
    margin-top: 28px;
    text-align: center;
  }
}
.toots {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 24px;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.5);
  height: 70px;
  line-height: 70px;
  padding-left: 20px;
  padding-right: 20px;
  border-radius: 6px;
  z-index: 999;
  white-space: nowrap;
}
/* 导航栏样式 */
nav {
  width: 100%;
  height: 260px;
  background-color: #1968a8;
  display: flex;
  justify-content: space-between;
  .multipleChoice,
  .save,
  .no {
    position: absolute;
    top: 0px;
    right: 30px;
    color: #fff;
    font-size: 34px;
    height: 124px;
    line-height: 124px;
  }
  .save {
  }
  .no {
    right: 120px;
  }
  .item {
    flex: 1;
    text-align: center;
    font-size: 34px;
    height: 124px;
    line-height: 124px;
    position: relative;
  }
  a.item {
    color: #fff;
  }
  .active,
  .router-link-exact-active {
    font-weight: 700;
  }
  .active::after,
  .router-link-exact-active::after {
    content: "";
    position: absolute;
    bottom: 24px;
    left: 50%;
    transform: translateX(-50%);
    width: 70px;
    height: 6px;
    border-radius: 6px;
    background-color: #fff;
  }
}
#app {
  height: 100%;
  color: #333;
}
.content {
  height: 100%;
  background-color: #f8f8f8;
}
/* 产品详情页和填写订单页共同的底部样式 */
.bottom-content {
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  padding-left: 30px;
  z-index: 10;
  width: 100%;
  // height: 110px;
  // height: calc(110px + safe-area-inset-height);
  line-height: 110px;
  background-color: #fff;
  border-top: 1px solid #ebebeb;
  box-shadow: 0 -2px 7px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: env(safe-area-inset-bottom);
  padding-bottom: constant(safe-area-inset-bottom);
  .monery {
    flex: 1;
    text-align: center;
    font-size: 30px;
    .total {
      padding-top: 6px;
    }
    .presentPrice {
      color: #ef2538;
      font-weight: 700;
      span {
      }
      span:first-child {
        font-size: 30px;
      }
      span:last-child {
        font-size: 50px;
      }
    }
  }
  /* 立即购买按钮 */
  .addShoppingCart {
    width: 540px;
    background-color: #1968a8;
    font-size: 32px;
    color: #fff;
    text-align: center;
    line-height: 110px;
  }
  .purchase {
    margin-right: 30px;
    width: 240px;
    height: 80px;
    line-height: 80px;
    border-radius: 80px;
    color: #fff;
    text-align: center;
    font-size: 32px;
    background-color: #c6c7c8;
  }
  .active.purchase {
    background-color: #1968a8;
  }
}
</style>
